import React, { useMemo } from 'react';
import { eachDayOfInterval, format } from 'date-fns';
import LazyWeekDaySection from './week/LazyWeekDaySection';
import '../styles/TeamLabelCalendar.css';

export default function TeamLabelCalendarWeekView({
  weekStart,
  weekEnd,
  companyHours,
  columns,
  appointmentsInRange,
}) {
  const days = eachDayOfInterval({ start: weekStart, end: weekEnd });

  const appointmentsByDayKey = useMemo(() => {
    const map = new Map();
    appointmentsInRange.forEach((a) => {
      const key = format(a.dateTime, 'yyyy-MM-dd');
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(a);
    });
    return map;
  }, [appointmentsInRange]);

  return (
    <div className="team-cal-v3-week">
      {days.map((day) => {
        const key = format(day, 'yyyy-MM-dd');
        const appointmentsForDay = appointmentsByDayKey.get(key) || [];

        return (
          <LazyWeekDaySection
            key={key}
            day={day}
            companyHours={companyHours}
            columns={columns}
            appointmentsForDay={appointmentsForDay}
          />
        );
      })}
    </div>
  );
}
